<div mat-dialog-content>
  <div class="mat-dialog-content">
    <div class="header-modal">
      <h1>Guia de Consulta</h1>
    </div>
    @if (isLoading) {
      <app-loading-progress-bar></app-loading-progress-bar>
    }
    <div class="body-modal">
      <form class="form" [formGroup]="model" (ngSubmit)="submit()" appFormscroll>
        <div class="row margin-section">
          <div class="col-12 col-sm-6 col-md-3">
            <app-select-2 [formControlField]="'idHealthcareAgreement'" (selectedValue)="onAnsChange($event)"
              [multiple]="false" [url]="urlListAnsRegistration" [idField]="'idHealthcareAgreement'"
              [nameField]="'ansWithName'" [labelField]="'1 - Registro ANS'"
              [preSelectedBlock]="this.idAppointmentGuide != null ? true : false">
            </app-select-2>
          </div>
          <div class="col-12 col-sm-6 col-md-3">
            <mat-form-field appearance="outline">
              <mat-label>2 - N° da guia no prestador</mat-label>
              <input matInput type="text" formControlName="guideNumber"
                [maxlength]="appointmentFieldsMaxLengthEnum.guideNumber"
                oninput="this.value = this.value.replace(/[^0-9]/g, ''); this.value = this.value.replace(/(\..*)\./g, '$1');">
                @if (model.get('guideNumber').invalid && !model.get('guideNumber').errors?.maxlength) {
                  <mat-error
                    >Preenchimento
                  incorreto</mat-error>
                }
                <mat-hint align="end">{{ model.get('guideNumber').value ?
                  model.get('guideNumber').value.length : 0
                }}/{{appointmentFieldsMaxLengthEnum.guideNumber}}</mat-hint>
              </mat-form-field>
            </div>
            <div class="col-12 col-sm-6 col-md-3">
              <mat-form-field appearance="outline">
                <mat-label>3 - N° da guia operadora</mat-label>
                <input matInput type="text" formControlName="guideOperatorNumber"
                  [maxlength]="appointmentFieldsMaxLengthEnum.guideOperatorNumber"
                  oninput="this.value = this.value.replace(/[^0-9]/g, ''); this.value = this.value.replace(/(\..*)\./g, '$1');">
                  @if (model.get('guideOperatorNumber').invalid && !model.get('guideOperatorNumber').errors?.maxlength) {
                    <mat-error
                      >Preenchimento
                    incorreto</mat-error>
                  }
                  <mat-hint align="end">{{ model.get('guideOperatorNumber').value ?
                    model.get('guideOperatorNumber').value.length : 0
                  }}/{{appointmentFieldsMaxLengthEnum.guideOperatorNumber}}</mat-hint>
                </mat-form-field>
              </div>
              <div class="col-12 col-sm-6 col-md-3">
                <mat-form-field appearance="outline">
                  <mat-label>Status da guia</mat-label>
                  <div class="adjust-select">
                    <div class="color-dot" [style.background-color]="guideStatusColor">
                    </div>
                    <div>
                      <mat-select class="select-spacing" formControlName="idGuideStatus" (selectionChange)="onGuideStatusChange($event.value)">
                        @for (item of listGuideStatus; track item) {
                          <mat-option [value]="item.idGuideStatus">
                            <span class="color-dot" [style.background-color]="item.color"></span>
                            {{item.name}}
                          </mat-option>
                        }
                      </mat-select>
                      @if (model.get('idGuideStatus').invalid) {
                        <mat-error>Selecione um status</mat-error>
                      }
                    </div>
                  </div>
                </mat-form-field>
              </div>
            </div>
            <div class="title-header">
              <h1>Dados do beneficiário (Paciente)</h1>
            </div>
            <div class="row margin-section">
              <div class="col-12 col-sm-6 col-md-3">
                <mat-form-field appearance="outline">
                  <mat-label>4 - N° carteira do beneficiário</mat-label>
                  <input matInput type="text"
                    [maxlength]="appointmentFieldsMaxLengthEnum.beneficiaryCardNumber"
                    formControlName="beneficiaryCardNumber"
                    oninput="this.value = this.value.replace(/[^0-9]/g, ''); this.value = this.value.replace(/(\..*)\./g, '$1');">
                    @if (model.get('beneficiaryCardNumber').invalid) {
                      <mat-error>Preenchimento
                      incorreto</mat-error>
                    }
                    <mat-hint align="end">{{ model.get('beneficiaryCardNumber').value ?
                      model.get('beneficiaryCardNumber').value.length : 0
                    }}/{{appointmentFieldsMaxLengthEnum.beneficiaryCardNumber}}</mat-hint>
                  </mat-form-field>
                </div>
                <div class="col-12 col-sm-6 col-md-3">
                  <mat-form-field appearance="outline">
                    <mat-label>5 - Validade da carteira</mat-label>
                    <input matInput [mask]="masks.date" type="text" formControlName="walletBeneficiaryValidity">
                    @if (model.get('walletBeneficiaryValidity').invalid) {
                      <mat-error>Data inválida</mat-error>
                    }
                  </mat-form-field>
                </div>
                <div class="col-12 col-sm-6 col-md-3">
                  <mat-form-field appearance="outline">
                    <mat-label>6 - Atendimento a Recém-Nascido</mat-label>
                    <mat-select formControlName="newborn">
                      <mat-option [value]="true">Sim</mat-option>
                      <mat-option [value]="false">Não</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
              <div class="row">
                <div class="col-12 col-sm-6 col-md-6">
                  <mat-form-field appearance="outline">
                    <mat-label>7 - Nome do beneficiário</mat-label>
                    <input matInput type="text" [maxlength]="appointmentFieldsMaxLengthEnum.beneficiaryName"
                      formControlName="beneficiaryName">
                      @if (model.get('beneficiaryName').invalid && !model.get('beneficiaryName').errors?.maxlength) {
                        <mat-error
                          >Preenchimento
                        incorreto</mat-error>
                      }
                      <mat-hint align="end">{{ model.get('beneficiaryName').value ?
                        model.get('beneficiaryName').value.length : 0
                      }}/{{appointmentFieldsMaxLengthEnum.beneficiaryName}}</mat-hint>
                    </mat-form-field>
                  </div>
                  <div class="col-12 col-sm-6 col-md-6">
                    <mat-form-field appearance="outline">
                      <mat-label>26 - Nome Social do beneficiário</mat-label>
                      <input matInput type="text"
                        [maxlength]="appointmentFieldsMaxLengthEnum.beneficiarySocialName"
                        formControlName="beneficiarySocialName">
                        <mat-hint align="end">{{ model.get('beneficiarySocialName').value ?
                          model.get('beneficiarySocialName').value.length : 0
                        }}/{{appointmentFieldsMaxLengthEnum.beneficiarySocialName}}</mat-hint>
                      </mat-form-field>
                    </div>
                  </div>
                  <div class="title-header">
                    <h1>Dados do contratado</h1>
                  </div>
                  <div class="row margin-section">
                    <div class="col-12 col-sm-6 col-md-3">
                      <mat-form-field appearance="outline">
                        <mat-label>Identificação no prestador</mat-label>
                        <mat-select formControlName="idProviderIdentityType"
                          (selectionChange)="checkProviderIdentityType($event.value)">
                          @for (item of listProviderIdentityType; track item) {
                            <mat-option
                              [value]="item.idProviderIdentityType">
                              {{item.name}}
                            </mat-option>
                          }
                        </mat-select>
                        @if (model.get('idProviderIdentityType').invalid) {
                          <mat-error>Selecione um
                          status</mat-error>
                        }
                      </mat-form-field>
                    </div>
                    <div class="col-12 col-sm-6 col-md-3">
                      <mat-form-field appearance="outline">
                        <mat-label>9 - Código do contratado</mat-label>
                        <input matInput type="text" [maxlength]="requesterCodeMaxLength"
                          formControlName="executionContractorOperatorCode" [mask]="requesterCodeMask"
                          (input)="inputNumber('executionContractorOperatorCode')">
                          @if (model.get('executionContractorOperatorCode').invalid && !model.get('executionContractorOperatorCode').errors?.maxlength) {
                            <mat-error
                              >Preenchimento
                            incorreto</mat-error>
                          }
                          <mat-hint align="end">{{ model.get('executionContractorOperatorCode').value ?
                            model.get('executionContractorOperatorCode').value.length : 0 }} /
                          {{ appointmentFieldsMaxLengthEnum.requesterCodeOperator }}</mat-hint>
                        </mat-form-field>
                      </div>
                      <div class="col-12 col-sm-6 col-md-6">
                        <mat-form-field appearance="outline">
                          <mat-label>10 - Nome do contratado</mat-label>
                          <input matInput type="text" [maxlength]="appointmentFieldsMaxLengthEnum.contractorName"
                            formControlName="contractorName">
                            @if (model.get('contractorName').invalid && !model.get('contractorName').errors?.maxlength) {
                              <mat-error
                                >Preenchimento
                              incorreto</mat-error>
                            }
                            <mat-hint align="end">{{ model.get('contractorName').value ?
                              model.get('contractorName').value.length : 0
                            }}/{{appointmentFieldsMaxLengthEnum.contractorName}}</mat-hint>
                          </mat-form-field>
                        </div>
                        <div class="col-12 col-sm-6 col-md-3">
                          <mat-form-field appearance="outline">
                            <mat-label>11 - CNES</mat-label>
                            <input matInput [mask]="masks.cnes" type="text"
                              [maxlength]="appointmentFieldsMaxLengthEnum.contractorCNES"
                              formControlName="contractorCNES">
                              @if (model.get('contractorCNES').invalid && !model.get('contractorCNES').errors?.maxlength) {
                                <mat-error
                                  >Preenchimento
                                incorreto</mat-error>
                              }
                              <mat-hint align="end">{{ model.get('contractorCNES').value ?
                                model.get('contractorCNES').value.length : 0
                              }}/{{appointmentFieldsMaxLengthEnum.contractorCNES}}</mat-hint>
                            </mat-form-field>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-12 col-sm-6 col-md-3">
                            @if (listProfessionalAgreementStruct && listProfessionalAgreementStruct.length > 0) {
                              <app-select-2
                                [formControlField]="'professional'" [list]="this.listProfessionalAgreementStruct"
                                [multiple]="false" [idField]="'idProfessionalAgreement'"
                                (selectedValue)="onProfessionalChange($event)" [nameField]="'nameProfessional'"
                                [labelField]="'12 - Nome do Profissional Executante'">
                              </app-select-2>
                            }
                          </div>
                          <div class="col-12 col-sm-6 col-md-3">
                            <mat-form-field appearance="outline">
                              <mat-label>13 - Conselho Profissional</mat-label>
                              <mat-select formControlName="idProfessionalCounseling">
                                @for (item of listProfessionalCouncil; track item) {
                                  <mat-option
                                    [value]="item.idProfessionalCouncil">
                                  {{ item.termCode }} - {{ item.councilName }}</mat-option>
                                }
                              </mat-select>
                            </mat-form-field>
                          </div>
                          <div class="col-12 col-sm-6 col-md-3">
                            <mat-form-field appearance="outline">
                              <mat-label>14 - N° do conselho Profissional</mat-label>
                              <input matInput type="text" formControlName="counselingNumber"
                                oninput="this.value = this.value.replace(/[^0-9]/g, ''); this.value = this.value.replace(/(\..*)\./g, '$1');">
                                @if (model.get('counselingNumber').invalid) {
                                  <mat-error>Preenchimento
                                  incorreto</mat-error>
                                }
                              </mat-form-field>
                            </div>
                            <div class="col-12 col-sm-6 col-md-3">
                              <mat-form-field appearance="outline">
                                <mat-label>15 - UF</mat-label>
                                <mat-select formControlName="idProfessionalUf">
                                  @for (item of listState; track item) {
                                    <mat-option [value]="item.idState">
                                    {{ item.stateCode }} - {{ item.stateName }}</mat-option>
                                  }
                                </mat-select>
                              </mat-form-field>
                            </div>
                            <div class="col-12 col-sm-6 col-md-3">
                              <mat-form-field appearance="outline">
                                <mat-label>16 - CBO</mat-label>
                                <mat-select formControlName="idProfessionalCbo">
                                  @for (item of listCbo; track item) {
                                    <mat-option [value]="item.idCbo">
                                    {{ item.cboCode }} - {{ item.cboName }}</mat-option>
                                  }
                                </mat-select>
                              </mat-form-field>
                            </div>
                          </div>
                          <div class="title-header margin-section">
                            <h1>Dados do Atendimento/Procedimento realizado</h1>
                          </div>
                          <div class="row">
                            <div class="col-12 col-sm-6 col-md-3">
                              <mat-form-field appearance="outline">
                                <mat-label>17 - Indicação de acidente</mat-label>
                                <mat-select formControlName="idAccidentIndication">
                                  @for (item of listAccidentIndication; track item) {
                                    <mat-option
                                      [value]="item.idAccidentIndication">
                                    {{item.termCode}} - {{item.name}}</mat-option>
                                  }
                                </mat-select>
                                @if (model.get('idAccidentIndication').invalid) {
                                  <mat-error>Preenchimento
                                  incorreto</mat-error>
                                }
                              </mat-form-field>
                            </div>
                            <div class="col-12 col-sm-6 col-md-3">
                              <mat-form-field appearance="outline">
                                <mat-label>18 - Data de realização</mat-label>
                                <input matInput [mask]="masks.date" type="text" formControlName="completionDate">
                                @if (model.get('completionDate').invalid) {
                                  <mat-error>Data inválida</mat-error>
                                }
                              </mat-form-field>
                            </div>
                            <div class="col-12 col-sm-6 col-md-3">
                              <mat-form-field appearance="outline">
                                <mat-label>19 - Tipo de consulta</mat-label>
                                <mat-select formControlName="idAppointmentType">
                                  @for (item of listAppointmentType; track item) {
                                    <mat-option [value]="item.idAppointmentType">
                                    {{item.termCode}} - {{item.name}}</mat-option>
                                  }
                                </mat-select>
                                @if (model.get('idAppointmentType').invalid) {
                                  <mat-error>Preenchimento
                                  incorreto</mat-error>
                                }
                              </mat-form-field>
                            </div>
                            <div class="col-12 col-sm-6 col-md-3">
                              <mat-form-field appearance="outline">
                                <mat-label>27 - Cobertura Especial</mat-label>
                                <mat-select formControlName="idSpecialCoverage">
                                  @for (item of listSpecialCoverage; track item) {
                                    <mat-option [value]="item.idSpecialCoverage">
                                    {{ item.termCode }} - {{item.specialCoverageDescription}}</mat-option>
                                  }
                                </mat-select>
                                @if (model.get('idSpecialCoverage').invalid) {
                                  <mat-error>Preenchimento
                                  incorreto</mat-error>
                                }
                              </mat-form-field>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-12 col-sm-6 col-md-4">
                              <mat-form-field appearance="outline">
                                <mat-label>28 - Regime De Atendimento</mat-label>
                                <mat-select formControlName="idCareRegime">
                                  @for (item of listCareRegime; track item) {
                                    <mat-option [value]="item.idCareRegime">
                                    {{ item.termCode }} - {{item.careRegimeDescription}}</mat-option>
                                  }
                                </mat-select>
                                @if (model.get('idCareRegime').invalid) {
                                  <mat-error>Preenchimento
                                  incorreto</mat-error>
                                }
                              </mat-form-field>
                            </div>
                            <div class="col-12 col-sm-6 col-md-4">
                              <mat-form-field appearance="outline">
                                <mat-label>29 - Saúde Ocupacional</mat-label>
                                <mat-select formControlName="idOccupationalHealth">
                                  @for (item of listOccupationalHealth; track item) {
                                    <mat-option
                                      [value]="item.idOccupationalHealth">
                                    {{ item.termCode }} - {{item.occupationalHealthName}}</mat-option>
                                  }
                                </mat-select>
                                @if (model.get('idOccupationalHealth').invalid) {
                                  <mat-error>Preenchimento
                                  incorreto</mat-error>
                                }
                              </mat-form-field>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-12 col-sm-6 col-md-3">
                              <mat-form-field appearance="outline">
                                <mat-label>20 - Tabela</mat-label>
                                <mat-select formControlName="idTerminologyGroup" (selectionChange)="selectTable()">
                                  @for (item of listTussTerminologyGroup; track item) {
                                    <mat-option
                                      [value]="item.idTerminologyGroup" [disabled]="item.idTerminologyGroup !== procedimentos">
                                    {{item.terminologyGroupCode}} - {{item.nameTerminologyGroup}}</mat-option>
                                  }
                                </mat-select>
                                @if (model.get('idTerminologyGroup').invalid) {
                                  <mat-error>Preenchimento
                                  incorreto</mat-error>
                                }
                              </mat-form-field>
                            </div>
                            <div class="col-12 col-sm-6 col-md-6">
                              <mat-form-field appearance="outline">
                                <mat-label>21 - Código do procedimento</mat-label>
                                <mat-select formControlName="idProcedure"
                                  (selectionChange)="onProcedureChange($event.value)">
                                  @for (item of listProcedureCode; track item) {
                                    <mat-option [value]="item.idProcedure">
                                      {{item.terminology.terminologyCode}} -
                                    {{item.terminology.terminologyName}}</mat-option>
                                  }
                                </mat-select>
                                @if (model.get('idProcedure').invalid) {
                                  <mat-error>Preenchimento
                                  incorreto</mat-error>
                                }
                              </mat-form-field>
                            </div>
                            <div class="col-12 col-sm-6 col-md-3">
                              <mat-form-field appearance="outline">
                                <mat-label>22 - Valor procedimento</mat-label>
                                <input matInput type="text" formControlName="procedureValue" currencyMask
                                  [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',', max: '999999.99', allowNegative: 'false' }">
                                  @if (model.get('procedureValue').invalid) {
                                    <mat-error>Preenchimento
                                    incorreto</mat-error>
                                  }
                                </mat-form-field>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-12 col-sm-12 col-md-12">
                                <mat-form-field appearance="outline">
                                  <mat-label>23 - Observação / Justificativa</mat-label>
                                  <textarea matInput type="text" [maxlength]="appointmentFieldsMaxLengthEnum.justification"
                                  formControlName="justification" oninput="this.value = this.value.replace(/[\n\r]/g, '');"></textarea>
                                  @if (model.get('justification').invalid && !model.get('justification').errors?.maxlength) {
                                    <mat-error
                                      >Preenchimento
                                    incorreto</mat-error>
                                  }
                                  <mat-hint align="end">{{ model.get('justification').value ?
                                    model.get('justification').value.length : 0
                                  }}/{{appointmentFieldsMaxLengthEnum.justification}}</mat-hint>
                                </mat-form-field>
                              </div>
                            </div>
                            <div mat-dialog-footer class="footer-modal">
                              <button mat-flat-button color="accent" class="btn-block" (click)="close()" type="button">
                                @if (!isLoading) {
                                  <span>Cancelar</span>
                                }
                                @if (isLoading) {
                                  <mat-spinner [diameter]="30" class="mat-spinner-btn"></mat-spinner>
                                }
                              </button>
                              <button form="sp-sadt-form" mat-flat-button color="primary"
                                class="btn-block" type="submit" (click)="submit()" [disabled]="!isEditingAllowed || !this.idHealthCareAgreement">
                                @if (!isLoading) {
                                  <span>Salvar</span>
                                }
                                @if (isLoading) {
                                  <mat-spinner [diameter]="30" class="mat-spinner-btn"></mat-spinner>
                                }
                              </button>
                              @if (this.appointmentGuideStruct && this.appointmentGuideStruct.guide && this.appointmentGuideStruct.guide.idGuide && this.data && !this.data.isAttendance) {
                                <button
                                  mat-flat-button color="accent" class="btn-block" type="button" (click)="print()">
                                  @if (!isLoading) {
                                    <span>Imprimir</span>
                                  }
                                  @if (isLoading) {
                                    <mat-spinner [diameter]="30" class="mat-spinner-btn"></mat-spinner>
                                  }
                                </button>
                              }
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>